/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'confluence.project-pages.improvement.provisioning-background.text': '不到一分鐘即可完成',
  'confluence.project-pages.improvement.provisioning-background.title': '設定您的專案頁面',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss': '關閉',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done': '完成',
  'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next': '下一步',
  'project-pages.activating.description': '連結的 Confuence 空間尚未就緒。如果重新整理無法解決問題，請{contactSupport}',
  'project-pages.activating.heading': 'Confluence 還在載入中',
  'project-pages.button.connect-different-space-or-page.label': '更新空間或頁面圖示',
  'project-pages.button.connect-different-space-or-page.tooltip': '連結不同的空間或頁面',
  'project-pages.button.connect-space-or-page.tooltip': '連結至 Confluence',
  'project-pages.button.go-to-connected-page.tooltip': '開啟 Confluence 中的頁面',
  'project-pages.button.go-to-connected-space.tooltip': '開啟 Confluence 中的空間',
  'project-pages.connect-space-dialog.connection-error': '連結失敗。',
  'project-pages.connect-space-dialog.connection-retry': '重試',
  'project-pages.connect-space-dialog.content.space-or-page-selector.description': '選擇要與專案連結的空間或頁面。',
  'project-pages.connect-space-dialog.content.space-or-page-selector.placeholder': '搜尋 Confluence',
  'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description':
    '此專案需先連結至空間，才可建立頁面。選擇要連結至此專案的空間。',
  'project-pages.connect-space-dialog.error-icon': '錯誤：',
  'project-pages.connect-space-dialog.footer.cancel': '取消',
  'project-pages.connect-space-dialog.footer.connect-space': '連結',
  'project-pages.connect-space-or-page-dialog.header.title': '將專案與 Confluence 連結',
  'project-pages.connect-space.description': '空間如同資料夾 - 您可使用空間來建立、整理和協作與專案相關的所有內容。',
  'project-pages.connect-space.not-connected.description':
    '若要使用專案頁面，請要求您的管理員或團隊負責人將 Confluence 連結到此專案。',
  'project-pages.connect-space.not-connected.heading': '未連結至 Confluence',
  'project-pages.connect-success-flag.description.content': '已成功連結 {connectedSpaceOrPageName} 內容。',
  'project-pages.connection-error.space-or-page-not-found.button': '連結至不同的空間或頁面',
  'project-pages.create-space-dialog.connection-error': '連結失敗。',
  'project-pages.create-space-dialog.connection-retry': '重試',
  'project-pages.create-space-dialog.content.empty-name': '請為您的空間命名。',
  'project-pages.create-space-dialog.content.invalid-name': '空間名稱必須包含至少一個字母或數字。',
  'project-pages.create-space-dialog.content.placeholder': '輸入空間名稱',
  'project-pages.create-space-dialog.creation-error': '空間建立失敗。',
  'project-pages.create-space-dialog.error-icon': '錯誤：',
  'project-pages.create-space-dialog.footer.cancel': '取消',
  'project-pages.create-space-dialog.footer.create-space': '建立',
  'project-pages.create-space-dialog.header.title': '建立新的 Confluence 空間',
  'project-pages.cross-join.access-revoked.templates.subtitle':
    '您無法使用專案頁面，因為管理員已拒絕您存取 Confluence。請連絡您的網站管理員以要求存取權。',
  'project-pages.cross-join.access-revoked.templates.title': '您沒有權限，無法使用專案頁面',
  'project-pages.cross-join.avatar.view-profile': '檢視設定檔',
  'project-pages.cross-join.denied-request.templates.subtitle':
    '您無法使用專案頁面，因為網站管理員已拒絕您加入 Confluence 的要求。',
  'project-pages.cross-join.denied-request.templates.title': '管理員已拒絕您的存取',
  'project-pages.cross-join.direct-access.button-subtitle.experimental':
    '您將取得 Confluence 的存取權。網站管理員已將您核准。',
  'project-pages.cross-join.errors.unknown-error.description': '如果重新整理無法修正問題，請{contactSupport}。',
  'project-pages.cross-join.errors.unknown-error.title': '現在無法顯示專案頁面',
  'project-pages.cross-join.inline-join-product.button': '存取 Confluence。網站管理員已將您核准。',
  'project-pages.cross-join.inline-join-product.connected.description': '從單一位置檢視、編輯和建立說明文件',
  'project-pages.cross-join.inline-join-product.connected.title': '與您的團隊在專案頁面上共同作業',
  'project-pages.cross-join.pending-request.templates.subtitle':
    '網站管理員已收到您要加入 Confluence 的要求。如果您已獲得加入的核准，專案頁面會開始運作，而我們會將確認電子郵件傳送給您。',
  'project-pages.cross-join.pending-request.templates.subtitle.experiment':
    '您獲得核准後，將收到一封電子郵件，其中包含「專案頁面」的存取權。',
  'project-pages.cross-join.pending-request.templates.title': '您已要求 Confluence 的存取權',
  'project-pages.cross-join.pending-request.templates.title.experiment': '存取權要求已傳送給管理員',
  'project-pages.cross-join.request-access-without-better-together.connected.description':
    '與您的團隊一起檢視、編輯和建立專案說明文件',
  'project-pages.cross-join.request-access.button': '要求存取權',
  'project-pages.cross-join.request-access.button-subtitle.experimental':
    '當您選取「加入您的團隊」時，即表示您要求加入 Confluence，並同意與管理員分享您的 Atlassian 設定檔。',
  'project-pages.cross-join.request-access.button.experimental': '加入您的團隊',
  'project-pages.cross-join.request-access.connected.description.experimental':
    '您的團隊正在使用「專案頁面」，在專案說明文件上留言、編輯和協作，全都無須離開 Jira。加入 Confluence 即可存取您專案的「專案頁面」。',
  'project-pages.cross-join.request-access.title': '專案頁面需要 Confluence 的存取權',
  'project-pages.cross-join.request-access.title.experiment': '為您的團隊建立單一事實來源',
  'project-pages.default-contextual-heading': '專案頁面由 Confluence 技術支援',
  'project-pages.default-contextual-message': 'Confluence 頁面讓您能在同一個地方建立、分享並協作您所有的專案文件。',
  'project-pages.default-reactivate-CTA': '重新啟用 Confluence',
  'project-pages.default-trial-CTA': '免費試用 30 天 Confluence',
  'project-pages.draft-saved-flag.action': '開啟草稿',
  'project-pages.draft-saved-flag.description': '您的草稿在發佈之前，只有您看得到。',
  'project-pages.draft-saved-flag.title': '已儲存草稿',
  'project-pages.embedded-pages.create-page-error.close-button': '關閉',
  'project-pages.embedded-pages.create-page-error.description': '發生問題，我們無法為您建立頁面。',
  'project-pages.embedded-pages.create-page-error.title': '我們無法建立頁面',
  'project-pages.embedded-pages.create-page-error.try-again-button': '再試一次',
  'project-pages.embedded-pages.modal.close.button.hint': '關閉',
  'project-pages.embedded-pages.modal.title.button': '在 Confluence 中開啟',
  'project-pages.embedded-pages.modal.title.button.hint': '在新索引標籤中開啟',
  'project-pages.errors.unknown-error.description.non-final': '如果重新整理無法解決問題，請{contactSupport}',
  'project-pages.errors.unknown-error.title.non-final': '現在無法顯示專案頁面',
  'project-pages.generic-error.button.reload': '重新載入頁面',
  'project-pages.generic-error.description': '發生錯誤。請稍後再試一次。',
  'project-pages.generic-error.description.non-final': '發生錯誤。請稍後再試一次。',
  'project-pages.generic-error.heading': '嗯，這有點奇怪...',
  'project-pages.generic-error.title.non-final': '嗯，這有點奇怪...',
  'project-pages.generic-info-flag.description': '發生錯誤。如果問題仍然存在，請再試一次或連絡支援人員',
  'project-pages.generic-success-flag.description.page': '已成功連結 {connectedSpaceOrPageName} 頁面。',
  'project-pages.generic-success-flag.description.space': '已成功與 {connectedSpaceOrPageName} 空間連結。',
  'project-pages.generic-success-flag.heading.page': '頁面已連結',
  'project-pages.generic-success-flag.heading.space': '空間已連結',
  'project-pages.granular-pages.connect-space-dialog.content.create-space-link.link-text': '或建立新空間',
  'project-pages.granular-pages.connect-space.button': '連結至 Confluence',
  'project-pages.granular-pages.connect-space.heading': '將此專案連結至 Confluence 空間或頁面',
  'project-pages.granular-pages.connect-space.heading.non-final': '將此專案連結至 Confluence 空間或頁面',
  'project-pages.improvement.contact-support': '連絡支援人員',
  'project-pages.improvement.errors.access-error.description': '請嘗試與網站管理員連絡以請求存取權。',
  'project-pages.improvement.errors.access-error.title': '您沒有檢視專案頁面的權限',
  'project-pages.improvement.errors.page-tree-unknown-error.description':
    '嘗試從您連結的 Confluence 空間顯示頁面時發生錯誤。如果重新整理無法解決問題，請{contactSupport}',
  'project-pages.improvement.errors.page-tree-unknown-error.title': '顯示專案頁面時發生問題',
  'project-pages.improvement.errors.space-or-page-not-found.description':
    '連結的 Confluence 空間或頁面已移動、封存或刪除。如果重新連結無法解決問題，請<link>連絡支援團隊</link>',
  'project-pages.improvement.errors.space-or-page-not-found.title': '找不到空間或頁面',
  'project-pages.improvement.errors.unknown-error.description': '如果重新整理無法解決問題，請{contactSupport}',
  'project-pages.improvement.errors.unknown-error.title': '現在無法顯示專案頁面',
  'project-pages.improvement.feature1': '無需離開 Jira 即可存取和建立文件',
  'project-pages.improvement.feature2': '適用於會議和衝刺計畫等用途的範本',
  'project-pages.improvement.feature3': '將文件同步到 Jira 以自動更新',
  'project-pages.improvement.heading-info': '掌握您的團隊，並改善完成工作的方式。',
  'project-pages.improvement.heading-info-v2': '為團隊的所有專案文件建立單一位置',
  'project-pages.improvement.learn-more-button': '了解更多',
  'project-pages.improvement.powered-by': '由以下技術支援：',
  'project-pages.improvement.powered-by.tooltip': '在新的索引標籤中開啟 Confluence',
  'project-pages.improvement.preview-teaser': '解鎖範本、專案頁面等等。',
  'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.description':
    '<p>透過自動更新狀態標籤，讓專案報告保持最新狀態。</p><p>只需將 Jira 工單連結到文件中，就會自動顯示與工單同步更新的狀態標籤，因此您可以省下手動製作報告的時間。</p>',
  'project-pages.improvement.provisioning-info-modal.seamlessly-update-stakeholders.title': '立即告知相關人員',
  'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.description':
    '<p>使用我們的內建範本建立一致的說明文件。這些範本使用方便，您可以根據需求自訂。</p><p>您可以直接從專案頁面使用範本，因此您不必離開正在工作的內容。<a>此處</a>可瀏覽所有範本。</p>',
  'project-pages.improvement.provisioning-info-modal.unify-documentation-standards.title': '統一您的說明文件標準',
  'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.description':
    '<p>從 Jira 中的專案頁面分頁中建立和管理說明文件，以建立重要資訊的單一事實來源。</p><p>您知道專案頁面是在 Confluence 上執行嗎？最多可供 10 位使用者免費使用。請在管理員設定中邀請團隊的其他人。</p>',
  'project-pages.improvement.provisioning-info-modal.your-project-pages-in-jira.title': '您的專案頁面，就在 Jira',
  'project-pages.improvement.templates.blank-page.description': '從頭開始建立一個頁面',
  'project-pages.improvement.templates.blank-page.name': '空白頁面',
  'project-pages.improvement.templates.decision.description': '記錄重要的專案決定，並與您的團隊進行溝通。',
  'project-pages.improvement.templates.decision.name': '決定',
  'project-pages.improvement.templates.meeting-notes.description': '設定會議議程、做筆記，並將交辦事項分享給您的團隊。',
  'project-pages.improvement.templates.meeting-notes.name': '會議筆記',
  'project-pages.improvement.templates.post-expand.more': '更多範本',
  'project-pages.improvement.templates.post-expand.more.tooltip': '檢視 Confluence 中所有的範本',
  'project-pages.improvement.templates.post-expand.subtitle': '熱門範本',
  'project-pages.improvement.templates.post-expand.title': '建立頁面',
  'project-pages.improvement.templates.pre-expand.more': '探索更多的範本',
  'project-pages.improvement.templates.pre-expand.subtitle': '受到像您們這樣的團隊歡迎。',
  'project-pages.improvement.templates.pre-expand.title': '預覽範本',
  'project-pages.improvement.templates.product-requirements.description': '為您的產品或功能定義、追蹤和限定需求範圍。',
  'project-pages.improvement.templates.product-requirements.name': '產品需求',
  'project-pages.improvement.templates.retrospective.description':
    '順利嗎？還有什麼可以改進？與您的團隊集思廣益如何改進。',
  'project-pages.improvement.templates.retrospective.name': '回顧',
  'project-pages.improvement.templates.template.disabled-tooltip': '請先與 Confluence 空間連結',
  'project-pages.improvement.templates.tutorial.content.confluence-templates':
    '<b>節省時間並減少手動任務</b>。Confluence 有很多頁面<a>範本</a>，因此您無須從頭開始。有技術文件、疑難排解指南、專案計畫、產品需求等多種範本。',
  'project-pages.improvement.templates.tutorial.content.edit-and-format':
    '<b>輕鬆編輯和設定格式。</b>使用頂端的編輯選單設定標準的文字格式，並透過輸入 <b>/</b> 輕鬆插入許多實用的整合功能。輸入 <c>/table</c> 即可插入表格，輸入 <c>/image</c> 即可插入圖片。您還可以使用 <c>/dropbox</c> 插入 Dropbox 連結、使用 <c>/microsoft</c> 插入 Microsoft office 工具，或使用 <c>/trello</c> 插入 Trello 看板和卡片。',
  'project-pages.improvement.templates.tutorial.content.forward-slash-prompt': '輸入 / 後方接著 ‘table’ 或 ‘image’',
  'project-pages.improvement.templates.tutorial.content.getting-started-tips': '這裡有幾個提示，可協助您開始：',
  'project-pages.improvement.templates.tutorial.content.handy-links': '實用的連結',
  'project-pages.improvement.templates.tutorial.content.jira-and-confluence': '一起使用 Jira 和 Confluence',
  'project-pages.improvement.templates.tutorial.content.jira-charts':
    '使用實際的 Jira 資料，在頁面上建立圖表。輸入 <c>/Jira charts</c>。',
  'project-pages.improvement.templates.tutorial.content.jira-links':
    '在頁面上的任何位置連結 Jira 議題。當您更新 Jira 議題時，頁面上的連結將即時更新。輸入 <c>/Jira</c>。',
  'project-pages.improvement.templates.tutorial.content.jira-roadmaps':
    '使用 Jira 專案為您的頁面嵌入互動式的藍圖和時間表。輸入 <c>/jira roadmap</c>。',
  'project-pages.improvement.templates.tutorial.content.jira-timeline':
    '使用 Jira 專案為您的頁面嵌入互動式時間軸。請輸入 <c>/jira 時間軸</c>。',
  'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic':
    '76％ 的 Jira Software 客戶表示，他們在新增 Confluence 後能更快交付專案',
  'project-pages.improvement.templates.tutorial.content.shipping-speed-statistic.spork-rebranding':
    '76％ 的 Jira 客戶表示，他們在新增 Confluence 後能更快交付專案',
  'project-pages.improvement.templates.tutorial.content.spaces-and-pages':
    '<b>使用空間和頁面</b>。空間是每個 Confluence 網站的一部分，並且是將頁面組織為類別的一種方式。將空間視為不同的資料夾或專案，而頁面則是屬於這些資料夾或專案中的文件。<a>進一步了解如何使用空間</a>',
  'project-pages.improvement.templates.tutorial.content.try-it-now': '立刻試用',
  'project-pages.improvement.templates.tutorial.description': '了解如何編輯頁面。',
  'project-pages.improvement.templates.tutorial.name': '歡迎來到「專案頁面」！',
  'project-pages.improvement.terms-and-conditions-v2':
    '選取「立即試用」即表示您確認將於 Confluence 中註冊，並且同意 Atlassian<termsLink> Cloud 服務條款</termsLink>和<privacyLink>隱私政策</privacyLink>。',
  'project-pages.improvement.title': '專案頁面',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-create-page-button': '建立頁面',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-description':
    '我們已新增 Confluence，以便您開始建立和連結所有專案文件。最多可供 10 位使用者免費使用。',
  'project-pages.improvement.transient-states.empty-state.auto-provisioned-learn-more-button': '了解更多',
  'project-pages.improvement.transient-states.empty-state.create-page-button': '建立您的第一個頁面',
  'project-pages.improvement.transient-states.empty-state.description':
    '建立一些會議筆記、產品要求、決策或其他內容，以查看此空間是否已填滿。',
  'project-pages.improvement.transient-states.empty-state.title': '這裡目前什麼都沒有，只有潛力無限',
  'project-pages.improvement.try-button': '在 Confluence 中試用此範本',
  'project-pages.improvement.try-it-now': '立刻試用',
  'project-pages.improvement.try-lozenge': '試用',
  'project-pages.improvement.try-on-demand-button': '免費試用',
  'project-pages.page-deleted-flag.title': '已刪除頁面。',
  'project-pages.page-published-flag.title': '您的頁面已發佈。',
  'project-pages.unknown-error.description': '如果重新整理無法解決問題，請{contactSupport}',
  'project-pages.unknown-error.heading': '現在無法顯示專案頁面',
  'projectpages.templatepreview.termsandprivacy':
    '按一下「免費試用」後，您將在 Confluence 中註冊並同意 Atlassian <termsOfServiceLinkText>Cloud 服務條款</termsOfServiceLinkText>和<privacyPolicyLinkText>隱私政策</privacyPolicyLinkText>。',
};
